export default __webpack_public_path__ + "static/media/resume.9e813050.jpg";